import React from "react";
import { useDropzone } from "react-dropzone";
import { Upload, FileText } from "lucide-react";

interface FileUploadProps {
  value?: File[];
  onChange: (files: File[]) => void;
}

export default function FileUpload({
  value = [],
  onChange,
}: FileUploadProps) {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
      "image/*": [".png", ".jpg", ".jpeg"],
    },
    multiple: true,
    onDrop: (acceptedFiles) => {
      onChange([...value, ...acceptedFiles]);
    },
  });

  return (
    <div className="space-y-3">
      <div
        {...getRootProps()}
        className="border-2 border-dashed rounded-lg p-6 text-center cursor-pointer hover:bg-gray-50"
      >
        <input {...getInputProps()} />

        <Upload className="mx-auto mb-2" size={24} />

        <p className="font-medium">
          Click or Drag & Drop Files
        </p>

        <p className="text-sm text-gray-500">
          PDF, JPG, PNG supported
        </p>
      </div>

      {value.length > 0 && (
        <div className="space-y-2">
          {value.map((file, index) => (
            <div
              key={index}
              className="flex items-center gap-2 border rounded p-2"
            >
              <FileText size={16} />
              <span className="text-sm truncate">
                {file.name}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}